import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Plus_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 3C16.5523 3 17 3.44772 17 4V15H28C28.5523 15 29 15.4477 29 16C29 16.5523 28.5523 17 28 17H17V28C17 28.5523 16.5523 29 16 29C15.4477 29 15 28.5523 15 28V17H4C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15H15V4C15 3.44772 15.4477 3 16 3Z"
            />
        </SvgStyled>
    );
};

export default Plus_lg;
